import { render } from "./renewal-rate-card.vue?vue&type=template&id=f6b9090e&ts=true"
import script from "./renewal-rate-card.vue?vue&type=script&lang=ts"
export * from "./renewal-rate-card.vue?vue&type=script&lang=ts"

import "./renewal-rate-card.vue?vue&type=style&index=0&id=f6b9090e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__